<template>
  <div class="bubble" :class="fromMe ? 'bubble--mine' : 'bubble--theirs'">
    <span class="bubble__date">{{ formatDate(message.created) }}</span>
    <MarkdownRenderer class="bubble__content" :content="message.content" />
  </div>
</template>

<script setup>
import MarkdownRenderer from '@/components/shared/MarkdownRenderer'
import { stringToDatetime } from '@/datetimeUtils'

defineProps({
  message: {
    type: Object,
    required: true,
  },
  fromMe: {
    type: Boolean,
    required: true,
  },
})

function formatDate(dateStr) {
  return stringToDatetime(dateStr)
}
</script>

<style scoped>
.bubble {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  max-width: 70%;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  word-break: break-word;
}

.bubble--theirs {
  align-self: flex-start;
  background: var(--gray-300);
  color: var(--text-black);
  border-bottom-left-radius: 2px;
}

.bubble--mine {
  align-self: flex-end;
  background: var(--halsa-green);
  color: white;
  border-bottom-right-radius: 2px;
}

.bubble__date {
  font-size: 0.65rem;
  white-space: nowrap;
}

.bubble--mine .bubble__date {
  color: rgba(255, 255, 255, 0.85);
}

.bubble--theirs .bubble__date {
  color: var(--text-grey);
}

.bubble__content {
  font-size: 0.9rem;
  line-height: 1.4;
}

.bubble--mine .bubble__content :deep(*) {
  color: white;
}

.bubble--theirs .bubble__content :deep(*) {
  color: var(--text-black);
}
</style>
